import { withRouter } from './Router';
var withNavigator = withRouter;
export default withNavigator;